import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

// components
import { HeaderProfileComponent } from '@shared/components/header-profile/header-profile.component';
import { FooterComponent } from "@shared/components/footer/footer.component";
import { CloseSessionModalComponent } from "@shared/components/close-session-modal/close-session-modal.component";
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderProfileComponent, FooterComponent, CloseSessionModalComponent],
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss'],
  providers: [AuthenticationService],
})
export class PrivateLayoutComponent {


  constructor(private authService: AuthenticationService, private router: Router, private modalService: ModalService) {}

  onCloseSession(event: any) {
    this.modalService.showCloseSession();
  }

  onConfirmCloseSession(confirmed: boolean) {
    if (confirmed) {
     this.authService.closeSession();
    }
  }
}
